import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.daysOptions,"label":_vm.label,"disabled":_vm.disabled,"readonly":_vm.readonly,"outlined":""},model:{value:(_vm.dayValue),callback:function ($$v) {_vm.dayValue=$$v},expression:"dayValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }